import schdulerMutations from "./mutations.js";
import schdulerActions from "./actions.js";
import schdulerGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: schdulerMutations,
  actions: schdulerActions,
  getters: schdulerGetters,
};
